module.exports = __webpack_public_path__ + "img/SE5569453854.c1c26fd0.svg";